// extracted by mini-css-extract-plugin
module.exports = {"empty":"StyleModelComp_empty__q8dSO","select":"StyleModelComp_select__ssgJS"};